import { TableHeadItemRecurse } from '../../../../../../components/TableHead';

export const subscriptionSubscriptionHistoryTableHead: TableHeadItemRecurse[] = [
  { title: 'Cliente', flex: 2 },
  { title: 'Assessor', flex: 2 },
  { title: 'Qtde. Solicitada' },
  { title: 'Valor' },
  { title: 'Status', flex: 1.5 },
  { title: '' },
];
